module.exports = __webpack_public_path__ + "img/aa736b7.jpg";